<style>
    .con-vs-popup .vs-popup {
        width: 1000px;
    }
</style>

<template>
    <div class="vx-col w-full mb-base">
        <vs-card class="p-4 mb-6">
            <div slot="header" class="flex flex-wrap items-center justify-between">
                <div class="flex items-center">
                    <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                    <h4 style="margin-left: 10px">Movement Order Detail</h4>
                </div>
                <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="savemovementorder" icon="save" :disabled="draftmovementorder.rowdata.length < 1 ? true : false">Save</vs-button>
            </div>
            <div class="vx-row mt-6">
                <div class="vx-col lg:w-1/4 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Reference*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="movementorder.reference" />
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Movement Date*
                        </div>
                        <div class="vx-col w-2/3">
                            <flat-pickr class="w-full" v-model="movementorder.movement_date" />
                        </div>
                    </div>
                </div>
                <div class="vx-col lg:w-1/4 w-full">
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Client ID*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-select
                                class="selectExample"
                                v-model="movementorder.client_id"
                                width="100%"
                                autocomplete
                                @input-change="searchDropdown($event, client)"
                            >
                                <vs-select-item v-for="(item, index) in client.data" :key="index" :value="item.id" :text="item.client_code"/>
                            </vs-select>
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Warehouse ID*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-select
                                class="selectExample"
                                v-model="movementorder.warehouse_id"
                                width="100%"
                                autocomplete
                                @input-change="searchDropdown($event, warehouse)"
                            >
                                <vs-select-item v-for="(item, index) in warehouse.data" :key="index" :value="item.id" :text="item.warehouses_code"/>
                            </vs-select>
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Auto Confirm
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-checkbox v-model="movementorder.auto_confirm"></vs-checkbox>
                        </div>
                    </div>
                </div>
            </div>
        </vs-card>
        <vs-card class="p-4 mb-6">
            <vs-row class="w-full flex justify-end">
                <vs-button @click="handleShowAddForm" :disabled="!movementorder.client_id || !movementorder.warehouse_id" class="btn mb-4 md:mb-0 mr-4" icon="add">Add</vs-button>
                <vs-button @click="handleDeleteForm" class="btn mb-4 md:mb-0" icon="remove">Remove</vs-button>
            </vs-row>
            <div style="max-height: 400px; overflow-x: auto" class="mt-5">
                <vs-table multiple v-model="selected" :data="draftmovementorder.rowdata" hoverFlat>
                    <template slot="thead">
                        <vs-th>Line ID</vs-th>
                        <vs-th>Product ID</vs-th>
                        <vs-th>Description</vs-th>
                        <vs-th>Pack ID</vs-th>
                        <vs-th>Batch</vs-th>
                        <vs-th>Exp. Date</vs-th>
                        <vs-th>Base Qty</vs-th>
                        <vs-th>Base UoM</vs-th>
                        <vs-th>Stock Type</vs-th>
                        <vs-th>Src. Loc. Type</vs-th>
                        <vs-th>Src. Loc. ID</vs-th>
                        <vs-th>Src. Loc. Storage</vs-th>
                        <vs-th>Dest. Loc. Type</vs-th>
                        <vs-th>Dest. Loc. ID</vs-th>
                        <vs-th>Dest. Loc. Storage</vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr :data="detail" :key="index" v-for="(detail, index) in data" >
                            <vs-td>{{ detail.line_id }}</vs-td>
                            <vs-td>{{ detail.product_code }}</vs-td>
                            <vs-td>{{ detail.description_1 }}</vs-td>
                            <vs-td>{{ detail.pack_id }}</vs-td>
                            <vs-td>{{ detail.batch }}</vs-td>
                            <vs-td>{{ detail.expired_date }}</vs-td>
                            <vs-td>{{ detail.base_qty }}</vs-td>
                            <vs-td>{{ detail.base_uom_name }}</vs-td>
                            <vs-td>{{ detail.stock_type_name }}</vs-td>
                            <vs-td>{{ detail.location_type_code }}</vs-td>
                            <vs-td>{{ detail.location_code }}</vs-td>
                            <vs-td>{{ detail.storage_unit }}</vs-td>
                            <vs-td>{{ detail.destination_location_type }}</vs-td>
                            <vs-td>{{ detail.destination_location }}</vs-td>
                            <vs-td>{{ detail.destination_storage_unit }}</vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </div>
        </vs-card>

        <vs-popup
            title="Items Detail"
            :active.sync="showdraftpopup"
            style="z-index: 99998"
        >
            <div class="con-exemple-prompt">
                <vs-tabs alignment="center">
                    <vs-tab label="Single Item">
                        <div class="vx-row mt-6">
                            <div class="vx-col lg:w-1/2 w-full">
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Product Code
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-select
                                            class="selectExample"
                                            v-model="singlemovementdata.product_id"
                                            width="100%"
                                            autocomplete
                                            @input-change="searchProduct($event)"
                                            @input="onProductChange"
                                        >
                                            <vs-select-item v-for="(item, index) in product" :key="index" :value="item.id" :text="getItemLabel(item)"/>
                                        </vs-select>
                                    </div>
                                </div>
                                <div class="vx-row mb-3 mt-1">
                                    <div class="vx-col w-1/3">
                                        Description
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input disabled class="w-full" v-model="singlemovementdata.description" />
                                    </div>
                                </div>
                                <div class="vx-row mb-3 mt-1">
                                    <div class="vx-col w-1/3">
                                        Pack ID
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="singlemovementdata.pack_id" />
                                    </div>
                                </div>
                                <div class="vx-row mb-3 mt-1">
                                    <div class="vx-col w-1/3">
                                        Batch
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="singlemovementdata.batch" />
                                    </div>
                                </div>
                                <div class="vx-row mb-3 mt-1">
                                    <div class="vx-col w-1/3">
                                        Expired Date
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <flat-pickr class="w-full" v-model="singlemovementdata.expired_date" />
                                    </div>
                                </div>
                                <div class="vx-row mb-3 mt-1">
                                    <div class="vx-col w-1/3">
                                        Src. Location Code
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-select
                                            class="selectExample"
                                            v-model="singlemovementdata.source_location_id"
                                            width="100%"
                                            autocomplete
                                            @change="sourceLocationChange"
                                        >
                                            <vs-select-item v-for="(item, index) in singlesourcelocations" :key="index" :value="item.id" :text="item.label"/>
                                        </vs-select>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col lg:w-1/2 w-full">
                                <div class="vx-row mb-3 mt-1">
                                    <div class="vx-col w-1/3">
                                        Qty
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <div class="vx-row">
                                            <div class="vx-col w-1/2">
                                                <vs-input class="w-full" v-model="singlemovementdata.qty" @input="convert"/>
                                            </div>
                                            <div class="vx-col w-1/2">
                                                <vs-select
                                                    class="selectExample"
                                                    v-model="singlemovementdata.uom_id"
                                                    width="100%"
                                                    autocomplete
                                                    @input="convert"
                                                >
                                                    <vs-select-item v-for="(item, index) in uoms" :key="index" :value="item.id" :text="item.name"/>
                                                </vs-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="vx-row mb-3 mt-1">
                                    <div class="vx-col w-1/3">
                                        Base Qty
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <div class="vx-row">
                                            <div class="vx-col w-1/2">
                                                <vs-input class="w-full" v-model="singlemovementdata.base_qty" disabled/>
                                            </div>
                                            <div class="vx-col w-1/2">
                                                <vs-input
                                                    class="w-full"
                                                    v-model="singlemovementdata.base_uom"
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="vx-row mb-3 mt-1">
                                    <div class="vx-col w-1/3">
                                        Stock Type
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-select
                                            class="selectExample"
                                            v-model="singlemovementdata.stock_type_id"
                                            width="100%"
                                            autocomplete
                                            @input-change="searchDropdown($event, stock_type)"
                                        >
                                            <vs-select-item v-for="(item, index) in stock_type.data" :key="index" :value="item.id" :text="item.name"/>
                                        </vs-select>
                                    </div>
                                </div>
                                <div class="vx-row mb-3 mt-1">
                                    <div class="vx-col w-1/3">
                                        Dest. Location
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-select
                                            class="selectExample"
                                            v-model="singlemovementdata.destination_location_id"
                                            width="100%"
                                            autocomplete
                                            @input-change="searchDest($event)"
                                            @change="changeDest"
                                        >
                                            <vs-select-item v-for="(item, index) in singledestlocations" :key="index" :value="item.id" :text="item.label"/>
                                        </vs-select>
                                    </div>
                                </div>

                                <div class="vx-row mb-3 mt-1">
                                    <div class="vx-col w-1/3">
                                        
                                    </div>
                                    <div class="vx-col w-2/3" v-show=isQr>
                                        <label>
                                        Stock tipe akan di ubah menjadi QR
                                        </label>
                                    </div>
                                    
                                </div>
                            </div>
                            <vs-row class="flex justify-end">
                                <vs-button
                                    @click="savesinglemovementdraft"
                                    class="mr-4"
                                    color="primary"
                                    type="filled"
                                >Next</vs-button>
                                <vs-button @click="showdraftpopup = false" type="flat">Cancel</vs-button>
                            </vs-row>
                        </div>
                    </vs-tab>
                    <vs-tab label="Multi Items by Location" @click="multiPopup">
                        <div class="vx-row mt-6">
                            <div class="vx-col lg:w-1/2 w-full">
                                <div class="vx-row mb-3 mt-1">
                                    <div class="vx-col sm:w-1/3 w-full">
                                        <span>Src. Location Code</span>
                                    </div>
                                    <div class="vx-col sm:w-2/3 w-full">
                                        <div class="vx-col sm:w-2/3 w-full">
                                            <vs-select
                                                class="selectExample"
                                                v-model="multimovementdata.source_location_id"
                                                width="100%"
                                                autocomplete
                                                @input-change="searchDest($event)"
                                            >
                                                <vs-select-item v-for="(item, index) in singlesourcelocations" :key="index" :value="item.id" :text="item.label"/>
                                            </vs-select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col lg:w-1/2 w-full">
                                <div class="vx-row mb-3 mt-1">
                                    <div class="vx-col sm:w-1/3 w-full">
                                        <span>Dest. Location Code</span>
                                    </div>
                                    <div class="vx-col sm:w-2/3 w-full">
                                        <vs-select
                                            class="selectExample"
                                            v-model="multimovementdata.destination_location_id"
                                            width="100%"
                                            autocomplete
                                            @input-change="searchDest($event)"
                                        >
                                            <vs-select-item v-for="(item, index) in singledestlocations" :key="index" :value="item.id" :text="item.label"/>
                                        </vs-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <vs-row class="flex justify-end">
                            <vs-button
                                @click="savemultimovementdraft"
                                class="mr-4"
                                color="primary"
                                type="filled"
                            >Next</vs-button>
                            <vs-button @click="showdraftpopup = false" type="flat">Cancel</vs-button>
                        </vs-row>
                    </vs-tab>
                </vs-tabs>
            </div>
        </vs-popup>
    </div>
</template>

<script>
import vSelect from "vue-select";
import { AgGridVue } from "ag-grid-vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
    components: {
        vSelect,
        AgGridVue,
        flatPickr
    },
    data() {
        return {
            selected: [],
            isQr: false,
            isLoading: false,
            movementorder: {
                client_id: null,
                reference: '',
                auto_confirm: false,
                warehouse_id: null,
                movement_date: new Date()
            },
            draftmovementorder: {
                gridoptions: {},
                columnDefs: [],
                rowdata: [],
                select: {}
            },
            showdraftpopup: false,
            clients: [],
            warehouses: [],
            singlemovementdata: {
                product_id: null,
                description: '',
                pack_id: '',
                batch: '',
                expired_date: '',
                source_location_id: null,
                qty: '',
                uom_id: null,
                base_qty: '',
                base_uom: '',
                stock_type_id: '',
                destination_location_id: null
            },
            multimovementdata: {
                source_location_id: null,
                destination_location_id: null
            },
            client: {
                data: [],
                loading: false,
                endpoint: 'master/clients',
                objectKey: 'client_code'
            },
            warehouse: {
                data: [],
                loading: false,
                endpoint: 'master/warehouses',
                objectKey: 'warehouses_code'
            },
            stock_type: {
                data: [],
                loading: false,
                endpoint: 'master/stocktypes',
                objectKey: 'name'
            },
            product: [],
            uoms: [],
            singlesourcelocations: [],
            singledestlocations: [],
        };
    },
    watch: {
        isLoading: function() {
            if (this.isLoading) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        }
    },
    methods: {
        getItemLabel(item) {
            let label = item.product_code;
            let barcode = item.uoms[0].barcode;

            if (barcode) {
                label += ` (${barcode})`;
            }

            console.log(item)

            return label;
        },
        back() {
            this.$router.go(-1);
        },
        // Logic
        conversion(data) {
            if (data.qty > 0) {
                data.base_qty = (data.qty / data.denominator) * data.numerator;
                data.err = false;
                data.errText = "";
            } else {
                data.base_qty = 0;
                data.err = true;
                data.errText = "qty must be higer than 0";
            }

            return data;
        },
        handleShowAddForm() {
            this.$vs.loading()
            this.product = [];
            this.singlesourcelocations = [];
            Promise.all([
                this.$http.post('master/product/showbyclient', { client_id: this.movementorder.client_id }),
                this.$http.post("master/stocktypes")
            ])
            .then(this.$http.spread((product, stocktypes) => {
                product.data.data.map(item => {
                    const uoms = item.uoms.map(uom => {
                        return {
                            id: uom.uom_id,
                            name: uom.uom.name,
                            numerator: uom.numerator,
                            denominator: uom.denominator,
                            barcode: uom.barcode,
                        }
                    })
                    
                    if(this.product.findIndex(p => p.id === item.id) === -1) {
                        this.product.push({ id: item.id, product_code: item.product_code, description_1: item.description_1, description_2: item.description_2, base_uom: item.base_uom, uoms: uoms })
                    }
                })
                
                this.stock_type.data = stocktypes.data.data
                this.showdraftpopup = true;
                this.$vs.loading.close();
                this.singlemovementdata = {
                    product_id: null,
                    description: '',
                    pack_id: '',
                    batch: '',
                    expired_date: '',
                    source_location_id: null,
                    qty: '',
                    uom_id: null,
                    base_qty: '',
                    base_uom: '',
                    stock_type_id: '',
                    destination_location_id: null
                }
            }))
            .catch(error => this.handleError(error))
        },
        searchProduct(e) {
            this.$http.post('master/product/showallproduct', { client_id: this.movementorder.client_id, product_code: e.target.value })
            .then(res => {
                res.data.data.map(item => {
                    const uoms = item.uoms.map(uom => {
                        return {
                            id: uom.uom_id,
                            name: uom.uom.name,
                            numerator: uom.numerator,
                            denominator: uom.denominator,
                            barcode: uom.barcode
                        }
                    })

                    if(this.product.findIndex(p => p.id === item.id) === -1) {
                        this.product.push({ id: item.id, product_code: item.product_code, description_1: item.description_1, description_2: item.description_2, base_uom: item.base_uom, uoms: uoms })
                    }
                })
            });
        },
        onProductChange() {
            this.$vs.loading();
            this.singlemovementdata.source_location_id = null;

            Promise.all([
                this.$http.post("master/locations"),
                this.$http.post("inventories/movementorder/sourcelocationall", {
                    client_id: this.movementorder.client_id,
                    warehouse_id: this.movementorder.warehouse_id,
                    product_id: this.singlemovementdata.product_id,
                    pack_id: this.singlemovementdata.pack_id,
                    exp_date: this.singlemovementdata.exp_date,
                    batch: this.singlemovementdata.batch,
                })
            ])
            .then(this.$http.spread((dest, src) => {
                const product = this.product[this.product.findIndex(p => p.id == this.singlemovementdata.product_id)];
                
                if(product) {
                    this.singlemovementdata.description = product.description_1;
                    this.singlemovementdata.base_uom = product.base_uom.uom.name;
                    this.uoms = product.uoms;

                    if(this.uoms.length) {
                        let first_uom_id = this.uoms[0].id;
                        if(first_uom_id) {
                            this.singlemovementdata.uom_id = first_uom_id;
                        }
                    }
                }

                this.singlesourcelocations = src.data.source_location.map(item => {
                    return {
                        id: item.id,
                        label: `${item.code} - ${item.location_code} (${item.available_qty} ${item.base_uom_name} - ${item.stock_type_code})`,
                        available_qty: item.available_qty,
                        stock_type_id: item.stock_type_id
                    }
                });

                if(this.singlesourcelocations.length) {
                    let first_location_id = this.singlesourcelocations[0].id;
                    if(first_location_id) {
                        this.singlemovementdata.source_location_id = first_location_id;
                    }
                }

                this.singledestlocations = dest.data.data.map(item => {
                    return {
                        id: item.id,
                        label: `${item.location_code}`,
                        loc_type_id: item.location_type_id
                    }
                });

                this.$vs.loading.close();
            }))
        },
        sourceLocationChange() {
            const singlesourcelocations = this.singlesourcelocations[this.singlesourcelocations.findIndex(p => p.id == this.singlemovementdata.source_location_id)];

            if(singlesourcelocations) {
                this.singlemovementdata.qty = singlesourcelocations.available_qty
                this.singlemovementdata.stock_type_id = singlesourcelocations.stock_type_id

                this.convert()
            }
        },
        convert() {
            const data = this.uoms[this.uoms.findIndex(a => a.id === this.singlemovementdata.uom_id)]
            if(data) {
                const numerator = data.numerator
                const denominator = data.denominator
    
                this.singlemovementdata.base_qty = (this.singlemovementdata.qty / denominator) * numerator
            }
        },
        searchDest(e) {
            console.log(e.target.value)
            this.$http.post("master/locations", {
                location_code: e.target.value
            })
            .then(dest => {
                dest.data.data.map(item => {
                    if(this.singledestlocations.findIndex(p => p.id === item.id) === -1) {
                        this.singledestlocations.push({
                            id: item.id,
                            label: `${item.location_code}`,
                            loc_type_id: item.location_type_id
                        })
                    }
                })
            })
        },
        changeDest(e) {
            let destLoc = this.singledestlocations.filter(obj => {
                            return obj.id === this.singlemovementdata.destination_location_id
                        })[0].loc_type_id;

            if(destLoc == '12'){

                this.singlemovementdata.stock_type_id = '3' 
                this.isQr = true           
            }
        },
        handleDeleteForm() {
            let indexes = []
            this.selected.map(item => {
                this.draftmovementorder.rowdata.map((detail, index) => {
                    if(detail.line_id == item.line_id) {
                        indexes.push(index)
                    }
                })
            })

            indexes.sort((a, b) => b - a)

            this.selected = []

            indexes.map(index => {
                this.draftmovementorder.rowdata.splice(index, 1)
            })
            this.assignLineId()
        },
        assignLineId() {
            this.draftmovementorder.rowdata.map((detail, index) => detail.line_id = index + 1)
        },
        // Handle Save
        savemovementorder() {
            this.isLoading = true;
            let drafts = this.$_.map(this.draftmovementorder.rowdata, 'draft_id');

            this.$http.post("inventories/movementorder/singleitem", {
                mo_header: {
                    reference: this.movementorder.reference || null,
                    movement_date: this.movementorder.movement_date || null,
                    client_id: this.movementorder.client_id,
                    warehouse_id: this.movementorder.warehouse_id,
                    auto_confirm: this.movementorder.auto_confirm || 0
                },
                draft_mo: drafts
            }).then(movementorder => {
                this.isLoading = false;
                this.$vs.notify({
                    color: "success",
                    title: "Movement Order Success",
                    iconPack: "feather",
                    icon: "icon-check",
                    text: "Sucess Saving!"
                });
                this.$router.push({ name: "movement-order" });
            })
            .catch(err => this.handleError(err))
            .then(() => (this.isLoading = false));
        },
        savesinglemovementdraft() {
            const data = {
                inventories_id: this.singlemovementdata.source_location_id,
                pack_id: this.singlemovementdata.pack_id,
                batch: this.singlemovementdata.batch,
                expired_date: this.singlemovementdata.expired_date,
                qty: this.singlemovementdata.qty,
                uom_id: this.singlemovementdata.uom_id,
                stock_type_id: this.singlemovementdata.stock_type_id,
                dest_location_id: this.singlemovementdata.destination_location_id,
            }

            this.isLoading = true;
            this.$http.post("inventories/movementorder/draftmo/singlestore", data)
            .then(draft_mo => {
                this.singlemovementdata = {
                    product_id: null,
                    description: '',
                    pack_id: '',
                    batch: '',
                    expired_date: '',
                    source_location_id: null,
                    qty: '',
                    uom_id: null,
                    base_qty: '',
                    base_uom: '',
                    stock_type_id: '',
                    destination_location_id: null
                };

                let tmpdata = draft_mo.data.draft_mo;
                tmpdata.line_id =
                    this.draftmovementorder.rowdata.length <= 0
                        ? 1
                        : this.draftmovementorder.rowdata[
                                this.draftmovementorder.rowdata.length - 1
                            ].line_id + 1;
                this.draftmovementorder.rowdata.push(tmpdata);
                this.showdraftpopup = false;
                this.isLoading = false;
            })
            .catch(error => this.handleError(error))
        },
        savemultimovementdraft() {
            this.isLoading = true;
            this.$http.post("inventories/movementorder/draftmo/multistore",
                {
                    location_id: this.multisourcelocations.select.location_id,
                    location_destination_id: this.multidestinationlocations
                        .select.location_id
            })
            .then(draft_mo => {
                this.showdraftpopup = false;
                this.showAdd = false;
                this.isLoading = false
                this.multimovementdata = {};
                draft_mo.data.draft_mo.forEach(datamo => {
                    let tmpdata = datamo;
                    tmpdata.line_id = this.draftmovementorder.rowdata.length <= 0 ? 1 : this.draftmovementorder.rowdata.length + 1;
                    this.draftmovementorder.rowdata.push(tmpdata);
                })
            })
            .catch(err => this.handleError(err))
        },
        // Get From API
        getClientData() {
            this.isLoading = true;
            this.clients = [];
            Promise.all([this.$http.post("master/clients/filter/dropdown")])
                .then(
                    this.$http.spread(clients => {
                        this.clients = clients.data;
                    })
                )
                .catch(err => {
                    this.$vs.notify({
                        color: "danger",
                        title: "Error saving!",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: err.response.data.message
                    });
                })
                .then(() => (this.isLoading = false));
        },
        getWarehouseData() {
            this.isLoading = true;
            this.warehouses = [];
            Promise.all([this.$http.post("master/warehouses/filter/dropdown")])
                .then(
                    this.$http.spread(warehouses => {
                        this.warehouses = warehouses.data;
                    })
                )
                .catch(err => {
                    this.$vs.notify({
                        color: "danger",
                        title: "Error saving!",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: err.response.data.message
                    });
                })
                .then(() => (this.isLoading = false));
        },
        fetchDropdown() {
            Promise.all([
                this.$http.post("master/clients"),
                this.$http.post("master/warehouses"),
            ])
            .then(this.$http.spread((client, warehouse) => {
                this.client.data = client.data.data
                this.warehouse.data = warehouse.data.data
                this.$vs.loading.close();
            }))
            .catch(error => {
                this.isLoading = false
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: 'Server Error',
                    text: 'Try again?',
                    accept: () => {
                        this.fetchDropdown()
                    },
                    cancel: () => this.$router.push({name: 'movement-order'}),
                    acceptText: 'Yes',
                    cancelText: 'No'
                })
            })
        },
        multiPopup() {
            console.log('mi');
        }
    },
    computed: {},
    mounted() {
        this.fetchDropdown();
        this.$vs.loading();
        // this.movementorder.client.id = this.$store.state.user.userconfig.clients.id;
        // this.movementorder.client.client_code = this.$store.state.user.userconfig.clients.client_code;
        // this.movementorder.warehouse.id = this.$store.state.user.userconfig.warehouses.id;
        // this.movementorder.warehouse.name = this.$store.state.user.userconfig.warehouses.name;
    },
};
</script>